import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, CheckCircle } from "lucide-react";

interface SymptomCheckerProps {
  title: string;
  symptoms: string[];
}

export const SymptomChecker = ({ title, symptoms }: SymptomCheckerProps) => {
  return (
    <Card className="border-destructive/30 bg-destructive/5">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-destructive" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground mb-4">Check if any of these apply to your website:</p>
        <ul className="space-y-3">
          {symptoms.map((symptom, index) => (
            <li key={index} className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-muted-foreground flex-shrink-0 mt-0.5" />
              <span>{symptom}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
